export const obterDadosEmpresariais = () => {
  return {
    nome: null,
    nome_fantasia: null,
    cpf_cnpj: '', // cnpj
    inscricao_estadual: null,
    inscricao_municipal: null,
    // representante_legal: null,
    opt_simples: false
  }
}
export const obterDadosPessoais = () => {
  return {
    nome: null,
    nome_fantasia: null, // apelido
    cpf_cnpj: '', // cpf
    rg: null,
    data_nascimento: null
  }
}
export const obterFormulario = () => {
  return {
    id: null,
    tipo: 1,
    id_contexto: null,
    informacoes: {
      pessoais: obterDadosPessoais(),
      empresariais: obterDadosEmpresariais(),
      observacoes: null,
      status: null,
      data_cadastro: null,
      data_inativacao: null,
      office: false,
      codigo_empresa: null,
      logotipo: [],
      endereco_logotipo: null
    },
    endereco: {
      cep: null,
      endereco: null,
      numero: null,
      complemento: null,
      bairro: null,
      cidade: null,
      uf: null,
      pais: 'Brasil'
    },
    contato: {
      email: null,
      celular: null,
      fone: null
    }
  }
}
export default {
  formulario: obterFormulario(),
  dadosRetorno: {
    sucesso: false,
    mensagem: '',
    listaDeErros: []
  },
  flagsDeControle: {
    carregandoDados: {
      status: false,
      mensagem: ''
    },
    manipulandoDados: {
      status: false,
      mensagem: ''
    },
    avisoDeErroNoFormulario: {
      exibir: false,
      mensagem: ''
    }
  },
  listaUsuariosRepresentanteLegal: [],
  listaUnidadesFederativas: [],
  gestaoProdutosHabilitado: false
}
